var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    className: "fill-current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    stroke: "none",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 265 c-9 -11 -25 -13 -65 -9 -64 8 -132 -20 -165 -67 -20 -27 -20 -30 -4 -54 9 -14 26 -30 36 -36 19 -10 19 -11 2 -30 -9 -10 -14 -22 -10 -26 7 -7 236 215 236 229 0 13 -17 9 -30 -7z m-50 -40 c-3 -5 -17 -9 -32 -7 -38 4 -72 -31 -64 -68 8 -42 -14 -56 -48 -29 -43 34 -32 65 39 103 32 17 113 18 105 1z m-46 -56 c-23 -24 -30 -27 -32 -14 -5 22 16 45 41 45 19 0 18 -2 -9 -31z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 211 c0 -5 7 -14 15 -21 8 -7 15 -20 15 -30 0 -34 -77 -80 -135 -80 -19 0 -35 -4 -35 -10 0 -17 72 -11 117 11 23 11 52 34 64 50 l20 29 -21 30 c-21 29 -40 39 -40 21z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 134 c-22 -23 -28 -34 -17 -34 19 0 55 35 55 55 0 19 1 20 -38 -21z",
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.920d92ed55f3e27230990f1fb1f54fd4.svg";
export { ForwardRef as ReactComponent };